module.exports = __webpack_public_path__ + "img/nav-bg.28129701.png";